import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import { Cookie } from 'shared/libs/cookie/cookie'

import { BASE_API_URL } from 'shared/config/base/base-url'

const headers = new Headers()

export const baseFetchQuery = fetchBaseQuery({
  baseUrl: BASE_API_URL,
  prepareHeaders: (headers) => {
    const CSRF_TOKEN = Cookie.getCookie('csrftoken')
    headers.set('X-CSRFToken', CSRF_TOKEN)

    return headers
  },
  credentials: 'include',
})

export const setAccessTokenHeaders = (token: string) => {
  headers.set('Authorization', `Bearer ${token}`)
}
